import { definePlugin } from '../../code-plug';

import { FormBuildersSidebar } from './views/form-builders-sidebar';

definePlugin('dashboard-form-builders', ({ registerView }, params) => {
  registerView('dashboard-sidebar', FormBuildersSidebar);
});
